// @flow

import reportError from './reportError';

export default function liquidErrorsReporter() {
  window.addEventListener('load', function() {
    if (document.body && document.body.innerHTML.indexOf('Liquid error:') > -1) {
      reportError('LiquidError detected');
    }
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/services/liquidErrorsReporter.js